import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import { SocialMediaService } from "./social-media.service";

@Component({
  selector: "app-icon-twitter",
  template: `<a
                href="{{ url | async }}"
                target="_blank"
                class="fab fa-twitter"></a>`,
  styleUrls: ["./icon-social-media.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTwitterComponent {

  constructor(
    private readonly socialMediaService: SocialMediaService
  ) { }

  get url(): Observable<string> {
    return this.socialMediaService.twitterUrl$;
  }
}
